module.exports = __webpack_public_path__ + "img/survey-library.efbe8766.png";